import { History, createBrowserHistory, createMemoryHistory } from 'history';

function createHistory(): History {
  return typeof window !== 'undefined'
    ? createBrowserHistory()
    : createMemoryHistory();
}

export default createHistory;
